import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const modules = [{
  name: 'BUILD',
  price: '$19',
  positioning: 'Para empezar a atraer prospectos con una estructura propia.',
  includes: ['Campañas paso a paso', 'CRM: guía operativa', 'Banco de videos para campañas', 'Guiones y recursos para iniciar', 'Acceso al módulo BUILD dentro de Skool'],
  benefit: 'Dejas de depender de referidos y empiezas a construir flujo.',
  cta: 'ENTRAR A BUILD',
  popular: false
}, {
  name: 'TRACK',
  price: '$47',
  positioning: 'Para dar seguimiento, activar reclutas y reducir abandono.',
  includes: ['Todo BUILD', '5 fases de seguimiento', 'Checklists operativos', 'Workflows CRM', 'Alertas y triggers', 'Recursos editables de seguimiento', 'Acceso al módulo TRACK dentro de Skool'],
  benefit: 'Dejas de perder personas por falta de atención y conviertes reclutas en agentes activos.',
  cta: 'ENTRAR A TRACK',
  popular: true
}, {
  name: 'SCALE',
  price: '$97',
  positioning: 'Para escalar reclutamiento con webinars, lanzamientos y mentoría.',
  includes: ['Todo BUILD', 'Todo TRACK', 'Estrategia de webinars', 'Lanzamientos para reclutamiento en masa', 'Mentoría semanal en vivo con Angel González', 'Biblioteca histórica de mentorías', 'Acceso al módulo SCALE dentro de Skool'],
  benefit: 'Dejas de crecer solo por esfuerzo individual y empiezas a multiplicar tu operación.',
  cta: 'ENTRAR A SCALE',
  popular: false
}];
export function ModulesSection() {
  return <section id="modulos" className="py-14 px-4 sm:px-6 lg:px-8 bg-brand-white relative border-t border-brand-gold/10" data-id="element-61">
      <div className="max-w-7xl mx-auto" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-63">
          <h2 className="font-heading font-bold text-3xl md:text-5xl uppercase tracking-tight text-brand-text mb-6" data-id="element-64">
            Elige el nivel de control que necesita tu operación
          </h2>
          <p className="text-xl text-brand-gold max-w-3xl mx-auto font-medium" data-id="element-65">
            Cada módulo tiene un precio mensual distinto y accesos específicos.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-66">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`relative flex flex-col bg-brand-white rounded-xl border ${mod.popular ? 'border-brand-gold shadow-[0_0_30px_rgba(200,149,43,0.15)] transform lg:-translate-y-4' : 'border-gray-200 shadow-sm'} p-5`} data-id="element-67">
              {mod.popular && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-68">
                  <span className="bg-brand-gold text-brand-black text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full" data-id="element-69">
                    Más Recomendado
                  </span>
                </div>}

              <div className="mb-4" data-id="element-70">
                <h3 className="font-heading font-bold text-3xl text-brand-text mb-1" data-id="element-71">
                  {mod.name}
                </h3>
                <div className="flex items-baseline mb-2" data-id="element-72">
                  <span className="text-4xl font-heading font-bold text-brand-gold" data-id="element-73">
                    {mod.price}
                  </span>
                  <span className="text-brand-text-muted ml-2" data-id="element-74">/mes</span>
                </div>
                <p className="text-brand-text-muted text-sm h-12" data-id="element-75">
                  {mod.positioning}
                </p>
              </div>

              <div className="flex-grow" data-id="element-76">
                <ul className="space-y-2 mb-4" data-id="element-77">
                  {mod.includes.map((item, i) => <li key={i} className="flex items-start" data-id="element-78">
                      <CheckIcon className="w-5 h-5 text-brand-gold shrink-0 mr-3 mt-0.5" data-id="element-79" />
                      <span className="text-brand-text-muted text-sm" data-id="element-80">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-81">
                <div className="bg-brand-dark p-3 rounded-lg mb-4 border border-brand-gold/10" data-id="element-82">
                  <p className="text-sm text-brand-gold font-medium italic" data-id="element-83">
                    "{mod.benefit}"
                  </p>
                </div>
                <a href="https://www.skool.com/reclutas-digitales-4277/about" target="_blank" rel="noopener noreferrer" className={`block w-full text-center py-4 font-heading font-bold uppercase tracking-wide rounded-md transition-all duration-300 ${mod.popular ? 'bg-gradient-to-r from-brand-gold to-brand-gold-bright text-brand-black hover:shadow-[0_0_20px_rgba(232,184,74,0.4)]' : 'bg-transparent border-2 border-brand-gold text-brand-gold hover:bg-brand-gold/10'}`} data-id="element-84">
                  {mod.cta}
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}